import './styles.scss';

import PropTypes from 'prop-types';
import React from 'react';

// icons list: https://thermoux.s3.amazonaws.com/komodo-icons.css
const Icon = ({
  dataTestId,
  name,
  size,
  color = 'black',
  disabled,
  onClick,
}) => {
  let iconClassName = `icon${size ? `-${size}` : ''}-${name}`;

  if (!name) {
    return null;
  }

  if (color) {
    iconClassName = `${iconClassName} icon-${color}`;
  }

  if (disabled) {
    iconClassName = `${iconClassName} icon-disabled`;
  }

  return (
    <span
      data-testid={dataTestId}
      className={iconClassName}
      onClick={onClick}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(['8', '16', '24', '32']),
  color: PropTypes.oneOf(['red', 'black', 'blue', 'success']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
};

export default Icon;
